const addToShoppingList = $('[role="addToShoppingList"]');
const shoppingListModal = $('#addToListModal');
const radio1 = addToShoppingList.find('#list1');
const radio2 = addToShoppingList.find('#list2');
const radio = addToShoppingList.find('[name=list]');
const formSelectGroup = addToShoppingList.find('.form-select-group-1');
const saveBtn = addToShoppingList.find('.saveBtn');
const listName = addToShoppingList.find('#listName');

const listContent1 = addToShoppingList.find('.modal-list-content-1');
const listContent2 = addToShoppingList.find('.modal-list-content-2');
const listContent3 = addToShoppingList.find('.modal-list-content-3');
const footer1 = addToShoppingList.find('.footer-1');
const footer2 = addToShoppingList.find('.footer-2');
const selectList1 = listContent1.find('select');

saveBtn.off('click');
saveBtn.on('click', function() {
    // save action
    let productId = $(this).data('product-id');
    let mode = $('#addToListModal input[name="list"]:checked').val();
    let newList = listName.val() ? listName.val() : null;
    let selected = selectList1 ? selectList1.val() : null;

    window.axios.post(window.config.urls.favorites.add, {
        product_id: productId,
        mode: mode,
        new: newList,
        selected: selected,
    }).then(({data}) => {
        if (data.success) {
            this.success = true;

            shoppingListModal.find('#addedToListModalContent').html(data.content);
            shoppingListModal.find('#addedToListModalContent').data('shoppinglist-url', data.url);



            listContent1.hide();
            listContent2.hide();
            listContent3.show();
            formSelectGroup.hide();
            footer1.hide();
            footer2.show();

            $("#addToExistingList").removeClass('d-none');

            updateDatalayer(
                'add_to_wishlist',
                data.cartItem.attributes.snapshot.material_number,
                data.cartItem.name,
                1,
                data.cartItem.price,
                null
            );
        }
    });
});
saveBtn.off('click.syskomp');


$('.go-to-shopping-list').off('click');
$('.go-to-shopping-list').on('click', function() {
    shoppingListModal.modal('hide');
    window.location.href = shoppingListModal.find('#addedToListModalContent').data('shoppinglist-url');
});
$('.go-to-shopping-list').off('click.syskomp');
